/**
 * O período das telas de produtos dos programas (dono, 05/10): o catálogo continua inteiro e
 * ganha a coluna "lançados no período"; `so` deixa só os produtos que tiveram lançamento.
 */
export type LancadosNoPeriodo = { readonly de: string; readonly ate: string; readonly so: boolean };

export function pedirLancados(p: URLSearchParams, l: LancadosNoPeriodo | null | undefined) {
  if (!l) return;
  p.set('de', l.de);
  p.set('ate', l.ate);
  if (l.so) p.set('soLancados', '1');
}
